import React, { useMemo } from 'react';
import { LayoutGrid } from 'lucide-react';

// Posiciones que Punto V crea para un tipo de máquina, agrupadas por decena
// (10–19, 20–29…), con la capacidad (máximo) de cada una.
const PosicionesTipo = ({ tipo }) => {
  const grupos = useMemo(() => {
    const porDecena = new Map();
    tipo.posiciones.forEach((p) => {
      const decena = Math.floor(p.pos / 10);
      if (!porDecena.has(decena)) porDecena.set(decena, []);
      porDecena.get(decena).push(p);
    });
    return [...porDecena.entries()].sort((a, b) => a[0] - b[0]);
  }, [tipo]);

  const capacidad = tipo.posiciones.reduce((acc, p) => acc + Number(p.maximo_maq), 0);

  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-100 flex items-center gap-2">
        <LayoutGrid size={16} className="text-blue-600" />
        <h4 className="text-sm font-semibold text-gray-800">Posiciones de {tipo.tipo}</h4>
        <span className="ml-auto text-xs text-gray-500 tabular-nums">
          {tipo.posiciones.length} posiciones · capacidad {capacidad}
        </span>
      </div>

      <div className="px-4 py-3 space-y-2 max-h-[26rem] overflow-y-auto">
        {grupos.map(([decena, posiciones]) => (
          <div key={decena} className="flex items-start gap-3">
            <span className="w-12 flex-shrink-0 pt-2 text-xs text-gray-400 tabular-nums">{decena * 10}–{decena * 10 + 9}</span>
            <div className="flex-1 grid grid-cols-[repeat(auto-fill,minmax(4rem,1fr))] gap-2">
              {posiciones.map((p) => (
                <div
                  key={p.pos}
                  title={`Posición ${p.pos}: capacidad ${p.maximo_maq}, mínimo ${p.minimo_maq}, existencia inicial ${p.existencia}`}
                  className="rounded-lg border border-gray-200 bg-gray-50 px-2 py-1.5 text-center"
                >
                  <div className="text-sm font-semibold text-gray-800 tabular-nums">{p.pos}</div>
                  <div className="text-xs text-gray-500 tabular-nums">{p.maximo_maq} u.</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <p className="px-4 pb-3 text-xs text-gray-400">
        Se crean con el producto genérico; después se asigna el producto real de cada posición en Punto V Manager.
      </p>
    </div>
  );
};

export default PosicionesTipo;
